import { useQuery } from '@tanstack/react-query'
import { api } from '@api'
import { NearbyVisibilityScope } from './types/nearbyTypes'

export interface NearbyVisibility {
  scope?: NearbyVisibilityScope
}

const fetchNearbyVisibility = async (): Promise<NearbyVisibility> => {
  const { data } = await api.get<NearbyVisibility>('/ft_nearby-visibility')
  return data
}

export const useGetNearbyVisibility = (enabled: boolean = true) => {
  return useQuery<NearbyVisibility>({
    queryKey: ['ft-nearby-visibility'],
    queryFn: fetchNearbyVisibility,
    staleTime: 5 * 60 * 1000,
    // Callers mounted outside an authenticated context (e.g. useTrackLocation
    // via WebLayout on /auth/*) must pass `false` — an unauthenticated request
    // 401s and the axios interceptor signs the visitor out of the login page.
    enabled,
  })
}
